import { InfoCircleTwoTone } from "@ant-design/icons";
import { Popover, Space } from "antd";
import {
    CardPhotoTypeNames,
    CardTitlePhotos
} from "models/cardIngestion";
import { FC } from "react";

const PhotoTaker: FC<{ photos: CardTitlePhotos[] }> = ({ photos }) => {
    if (photos.length === 0) {
        return <></>;
    }

    const name = photos[0].takenByName;
    if (photos.every(p => p.takenByName === name)) {
        return <>{name}</>
    }

    const content = <Space direction="vertical" size="middle">
        {photos.map((p, idx) => <div key={idx}>
            {CardPhotoTypeNames[p.type]}: {p.takenByName}</div>
        )}
    </Space>;

    return <Space>
        <span>{`${photos.length} Users`}</span>
        <Popover content={content} >
            <InfoCircleTwoTone style={{ cursor: 'pointer' }} />
        </Popover>
    </Space>
};

export default PhotoTaker;